export enum QuizPage {
  // Section 0: Intro
  privacy = 'privacy',
  name = 'name',
  usps = 'usps',
  birthday = 'birthday',
  // birthdayIllustrationsABTest
  ageRange = 'age-range',
  // birthdayIllustrationsABTest

  // Section 1: Goal
  fertilityGoal = 'fertility-goal',
  fertilityGoalInfo = 'fertility-goal-info',
  birthControlMethod = 'birth-control-method',
  birthControlMethodInfo = 'birth-control-method-info',
  sideEffects = 'side-effects',
  sideEffectsInfo = 'side-effects-info',
  plannedPregnancyTiming = 'planned-pregnancy',
  learnAboutSexInfo = 'learn-about-sex-info',
  bestTimeInCycle = 'best-time-in-cycle',
  knowingYourSexDrive = 'knowing-your-sex-drive',
  sexDriveInfo = 'sex-drive-info',
  sexFrequency = 'sex-frequency',
  knowPregnantDays = 'know-pregnant-days',
  menstrualCycleInfo = 'menstrual-cycle-info',
  testimonialInfo = 'testimonial-info',

  // Section 2: Cycle
  hormonalBirthControlUsage = 'hormonal-birth-control-usage',
  hormonalBirthControlHowLongPlan = 'hormonal-birth-control-how-long-plan',
  hormonalBirthControlHowLongPrevent = 'hormonal-birth-control-how-long-prevent',
  cycleLength = 'cycle-length',
  periodRegularity = 'period-regularity',
  periodRegularityInfo = 'period-regularity-info',
  cycleStartDate = 'cycle-start-date',
  // OurSyncABTest
  lastPeriodDate0 = 'last-period-date-0',
  lastPeriodDate1 = 'last-period-date-1',
  lastPeriodDate2 = 'last-period-date-2',
  lastPeriodDate3 = 'last-period-date-3',
  lastPeriodDate4 = 'last-period-date-4',
  lastPeriodDate5 = 'last-period-date-5',
  medicalConditionsPlan = 'medical-conditions-plan',
  medicalConditionsPrevent = 'medical-conditions-prevent',
  medicalConditionsInfo = 'medical-conditions-info',
  compareBirthControl = 'compare-birth-control',
  doctorInvolvement = 'doctor-involvement',
  partnerInvolvement = 'partner-involvement',
  partnerInvolvementInfo = 'partner-involvement-info',
  followPregnancyInfo = 'follow-pregnancy-info',
  plannedPregnancyInfo = 'planned-pregnancy-info',

  // Section 3: Cycle Changes
  cycleChangesStart = 'cycle-changes-start',
  cycleChangesEmotionalRange = 'emotional-range',
  cycleChangesEmotionalRangeInfo = 'emotions-info',
  cycleChangesSkinConditions = 'skin-conditions',
  cycleChangesSkinInfo = 'skin-info',
  cycleChangesMucusTypes = 'cervical-mucus-types',
  cycleChangesSexDrive = 'sex-drive-changes',
  cycleChangesSexDriveAndMucusInfo = 'sex-and-mucus-info',
  cycleChangesPainSymptoms = 'pain-symptoms',
  cycleChangesPainSymptomsInfo = 'pain-info',
  trackingInfo = 'tracking-info',

  // Section 4: Routine
  naturalMethod = 'natural-method',
  yourMeasuringDevice = 'your-measuring-device',
  whichWearable = 'which-wearable',
  consideringPurchase = 'considering-purchase',
  eligibleAppleWatch = 'eligible-apple-watch',
  purchaseNewWatch = 'purchase-new-watch',
  howDoYouSleep = 'how-do-you-sleep',
  sleepWearable = 'sleep-wearable',
  wearYourWatchToBed = 'wear-your-device-to-bed',
  yourDescription = 'your-description',
  fitResult = 'fit-result',
  deviceResult = 'device-result',
}
